module.exports = __webpack_public_path__ + "img/Edit_24.661be276.svg";